import React from 'react';
import CmsFooterView from './CmsFooterView';

function CmsFooter() {
  const props = {};
  return <CmsFooterView {...props} />;
}

export default CmsFooter;
